const registerGlobal = window.DNARegisterGlobal

/**
 * Gets the value of a given cookie
 * @param {*} cookieName
 */
const getCookie = (cookieName) => {
  const name = `${cookieName}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const decodedCookieValues = decodedCookie.split(';')
  for (let i = 0; i < decodedCookieValues.length; i++) {
    let cookieString = decodedCookieValues[i]
    while (cookieString.charAt(0) === ' ') {
      cookieString = cookieString.substring(1)
    }
    if (cookieString.indexOf(name) === 0) {
      return cookieString.substring(name.length, cookieString.length)
    }
  }
  return ''
}

class SegmentClient {
  constructor() {
    this.cartToken = getCookie('cart')
    this.CONSTANTS = {
      BRAND: 'Rothys',
      CURRENCY: 'USD',
      SENT_FROM: 'website',
      EVENTS: {
        SPLIT_CAROUSEL_CLICKED: '50/50 Carousel Clicked',
        ACCORDION_OPENED: 'Accordion Opened',
        ACCOUNT_CREATED: 'Account Created',
        ACCOUNT_CREATION_STARTED: 'Account Creation Started',
        ACCOUNT_DETAILS_UPDATED: 'Account Details Updated',
        ACCOUNT_ICON_CLICKED: 'Account Icon Clicked',
        ACCOUNT_MENU_ITEM_CLICKED: 'Account Menu Item Clicked',
        ADD_ADDRESS: 'Add Address',
        BANNER_BLOCK_CLICKED: 'Banner Block Clicked',
        BANNER_BLOCK_SCROLLED: 'Banner Block Scrolled',
        BIS_SUBMISSION: 'BIS Submission',
        BREADCRUMB_CLICKED: 'Breadcrumb Clicked',
        CART_ADDON_CLICKED: 'Cart Addon Clicked',
        CART_ADDON_CTA_CLICKED: 'Cart Addon CTA Clicked',
        CART_CHECKOUT_BUTTON_CLICKED: 'Cart Checkout Button Clicked',
        CART_ICON_CLICKED: 'Cart Icon Clicked',
        CART_INSOLE_UPSELL_ADDED: 'Cart Insole Upsell Added',
        CART_ITEM_QUANTITY_INCREASED: 'Cart Item Quantity Increased',
        CART_ITEM_QUANTITY_DECREASED: 'Cart Item Quantity Decreased',
        CART_VIEWED: 'Cart Viewed',
        CATEGORIES_BLOCK_CLICKED: 'Categories Block Clicked',
        CHANGE_DEFAULT_ADDRESS: 'Change Default Address',
        CHAT_CLICKED: 'Chat Clicked',
        COLLECTION_FEATURED_FILTER_CLICKED:
          'Collection Featured Filter Clicked',
        COLLECTION_LOAD_MORE: 'Collection Load More Clicked',
        CONTACT_FORM_SUBMISSION: 'Contact Form Submission',
        COUNTRY_SWITCHED: 'Country Switched',
        COUNTRY_SWITCHER_OPENED: 'Country Switcher Opened',
        COUPON_DENIED: 'Coupon Denied',
        COUPON_REMOVED: 'Coupon Removed',
        CROSS_SELL_BLOCK_CLICKED: 'Cross Sell Block Clicked',
        DELETE_ADDRESS: 'Delete Address',
        DISCOUNT_ELIGIBILITY_CLICKED: 'Discount Eligibility Button Clicked',
        DISCOUNT_VERIFICATION_STARTED: 'Discount Verification Started',
        EDIT_ADDRESS: 'Edit Address',
        EMAIL_CAPTURED: 'Email Captured',
        EMPC_SCROLLED: 'Editorial Multi-Product Carousel Scrolled',
        EMPC_PRODUCT_CLICKED:
          'Editorial Multi-Product Carousel Product Clicked',
        EMPC_LINK_CLICKED: 'Editorial Multi-Product Carousel Link Clicked',
        EPC_SCROLLED: 'Editorial Product Carousel Scrolled',
        EPC_PRODUCT_CLICKED: 'Editorial Product Carousel Product Clicked',
        EPC_LINK_CLICKED: 'Editorial Product Carousel Link Clicked',
        EXPERIMENT_VIEWED: 'Experiment Viewed',
        EXPRESS_CHECKOUT_INITIATED: 'Express Checkout Initiated',
        FAQ_ANSWER_VIEWED: 'FAQ Answer Viewed',
        FAQ_SEARCHED: 'FAQ Searched',
        FEATURED_BLOCK_CLICKED: 'Featured Collections Block Clicked',
        FILTER_ADDED: 'Filter Added',
        FILTER_REMOVED: 'Filter Removed',
        FILTERS_CLEARED: 'Filters Cleared',
        FILTERS_VIEWED: 'Filters Viewed',
        FLEXIBLE_BLOCK_CLICKED: 'Flexible Block Clicked',
        FOOTER_EMAIL_SIGNUP: 'Footer Email Signup',
        FOOTER_MENU_SECTION_EXPANDED: 'Footer Menu Section Expanded',
        FOOTER_MENU_ITEM_CLICKED: 'Footer Menu Item Clicked',
        FOOTER_SMS_SIGNUP: 'Footer SMS Signup',
        FORGOT_PASSWORD: 'Forgot Password',
        GIFT_CARD_LOOKUP: 'Gift Card Lookup',
        GIFT_NOTE_ADDED: 'Gift Note Added',
        HEADER_LOGO_CLICKED: 'Header Logo Clicked',
        HORIZONTAL_SLIDER_CLICKED: 'Horizontal Slider Clicked',
        HORIZONTAL_SLIDER_SCROLLED: 'Horizontal Slider Scrolled',
        HOT_SPOT_EXPANDED: 'Hot Spot Expanded',
        HOT_SPOT_LINK_CLICKED: 'Hot Spot Link Clicked',
        HYPE_BANNER_CLICKED: 'Hype Banner Clicked',
        IN_GRID_CONTENT_CLICKED: 'In Grid Content Clicked',
        INTERACTIVE_ACCORDION_CLICKED: 'Interactive Accordion Clicked',
        JOIN_WAITLIST_CLICKED: 'Join Waitlist Clicked',
        LOGIN_LINK_CLICKED: 'Login Link Clicked',
        LOGIN: 'Login',
        LOGOUT: 'Logout',
        MAIN_MENU_CLOSED: 'Main Menu Closed',
        MAIN_MENU_ITEM_CLICKED: 'Main Menu Item Clicked',
        MAIN_MENU_OPENED: 'Main Menu Opened',
        MAIN_MENU_SECTION_EXPANDED: 'Main Menu Section Expanded',
        MISSION_BANNER_CLICKED: 'Mission Banner Clicked',
        NOTIFICATION_BAR_CLICKED: 'Notification Bar Clicked',
        NOTIFICATION_BAR_SCROLLED: 'Notification Bar Scrolled',
        ORDER_CLICKED: 'Order Clicked',
        ORDER_REORDER_CLICKED: 'Order Reorder Clicked',
        ORDER_RETURN_CLICKED: 'Order Return Clicked',
        ORDER_REVIEW_CLICKED: 'Order Write Review Clicked',
        ORDER_TRACK_CLICKED: 'Order Track Clicked',
        PAGE_VIEWED: 'Loaded a Page',
        PDP_CONTENT_CTA_CLICKED: 'PDP Content CTA Clicked',
        PDP_GENDER_LINK_CLICKED: 'PDP Dual Gender Link Clicked',
        PDP_SPECIAL_MESSAGE_CLICKED: 'PDP Special Message Clicked',
        PDP_PRODUCT_TOGGLE_CLICKED: 'PDP Product Toggle Clicked',
        PREFERENCE_FORM_CLICKED: 'Preference Form Clicked',
        PREFERENCE_FORM_EMAIL_SIGNUP: 'Preference Form Email Signup',
        PREFERENCE_FORM_SUBMITTED: 'Preference Form Submitted',
        PRODUCT_ADDED: 'Product Added',
        PRODUCT_ADDONS_SCROLLED: 'Product Addons Scrolled',
        PRODUCT_ADDONS_CLICKED: 'Product Addon Clicked',
        PRODUCT_ADDONS_CTA_CLICKED: 'Product Addon CTA Clicked',
        PRODUCT_CARD_GALLERY_SCROLLED: 'Product Card Gallery Scrolled',
        PRODUCT_CARD_GALLERY_SLIDE_CLICKED:
          'Product Card Gallery Slide Clicked',
        PRODUCT_CARD_SLIDE_CLICKED: 'Product Card Slide Clicked',
        PRODUCT_CARD_SLIDE_VIEWED: 'Product Card Slide Viewed',
        PRODUCT_CAROUSEL_CLICKED: 'Product Carousel Clicked',
        PRODUCT_CAROUSEL_CTA_CLICKED: 'Product Carousel CTA Clicked',
        PRODUCT_CAROUSEL_SCROLLED: 'Product Carousel Scrolled',
        PRODUCT_CLICKED: 'Product Clicked',
        PRODUCT_CTA_CLICKED: 'Product CTA Clicked',
        PRODUCT_IMAGE_CLICKED: 'Product Image Clicked',
        PRODUCT_IMAGE_SCROLLED: 'Product Image Scrolled',
        PRODUCT_IMAGE_VIEWED: 'Product Image Viewed',
        PRODUCT_LIST_FILTERED: 'Product List Filtered',
        PRODUCT_LIST_VIEWED: 'Product List Viewed',
        PRODUCT_REMOVED: 'Product Removed',
        PRODUCT_VIEWED: 'Product Viewed',
        PRODUCTS_SEARCHED: 'Products Searched',
        QUICK_LINK_CLICKED: 'Quick Link Clicked',
        QUICK_SHOP_DETAILS_CLICKED: 'Quick Shop Full Details Clicked',
        QUICK_SHOP_VARIANT_CLICKED: 'Quick Shop Variant Clicked',
        QUICK_VIEW_OPENED: 'Quick View Opened',
        QUICK_VIEW_FULL_DETAILS_CLICKED: 'Quick View Full Details Clicked',
        REVIEWS_FILTERED: 'Reviews Filtered',
        REVIEW_DOWNVOTED: 'Review Downvoted',
        REVIEW_DOWNVOTE_REMOVED: 'Review Downvote Removed',
        REVIEW_IMAGE_CLICKED: 'Review Image Clicked',
        REVIEW_STARS_CLICKED: 'Review Stars Clicked',
        REVIEW_SUBMITTED: 'Review Submitted',
        REVIEW_UPVOTED: 'Review Upvoted',
        REVIEW_UPVOTE_REMOVED: 'Review Upvote Removed',
        REVIEWS_PAGINATION_CLICKED: 'Reviews Pagination Clicked',
        SEARCHANDISING_BANNER_CLICKED: 'Searchandizing Banner Clicked',
        SEARCH_ICON_CLICKED: 'Search Icon Clicked',
        SEARCH_SUGGESTED_TERM_CLICKED: 'Search Suggested Term Clicked',
        SEARCH_VIEW_RESULTS_CLICKED: 'Search View Results Clicked',
        SIZE_CHART_CLICKED: 'Size Chart Clicked',
        SIZE_SYSTEM_SELECTED: 'Size System Selected',
        SLP_IMAGE_SELECTOR_INTERACTION: 'SLP Image Selector Interaction',
        SORT_ADDED: 'Sort Added',
        SORTS_VIEWED: 'Sorts Viewed',
        SPLIT_BANNER_CLICKED: 'Split Banner Clicked',
        START_SESSION: 'Start Session',
        STORE_AVAILABILITY_STORE_CLICKED: 'Store Name Clicked',
        STORE_AVAILABILITY_CHECK_ADDITIONAL: 'Check Additional Stores Clicked',
        STORE_AVAILABILITY_VIEW_ALL: 'View All Stores Clicked',
        STORE_CLICKED: 'Store Clicked',
        STORE_ACCORDION_OPENED: 'Store Accordion Opened',
        STORE_CONTENT_BLCOK_CLICKED: 'Store Content Block Clicked',
        STORE_DIRECTIONS_CLICKED: 'Store Directions Clicked',
        STORE_EMAIL_SIGNUP: 'Store Email Signup',
        STORES_FILTER_CLICKED: 'Stores Location Type Clicked',
        STORES_GEOLOCATED: 'Use Current Location Clicked',
        STORES_REGION_CLICKED: 'Stores Region Clicked',
        STORES_SEARCHED: 'Stores Searched',
        SWATCH_CLICKED: 'Swatch Clicked',
        SWATCH_HOVERED: 'Swatch Hovered',
        TRANSPARENT_CAROUSEL_CLICKED: 'Transparent Carousel Clicked',
        TRIPTYCH_CLICKED: 'Triptych Clicked',
        TRIPTYCH_SCROLLED: 'Triptych Scrolled',
        UGC_POST_CLICKED: 'UGC Post Clicked',
        UGC_POST_PRODUCT_ADDED: 'UGC Product Added to Cart',
        UGC_POST_PRODUCT_CLICKED: 'UGC Product Clicked',
        VARIANT_CLICKED: 'Variant Clicked',
        VIDEO_CC_TOGGLED: 'Video CC Toggled',
        VIDEO_COMPLETED: 'Video Completed',
        VIDEO_MUTE_TOGGLED: 'Video Mute Toggled',
        VIDEO_PAUSED: 'Video Paused',
        VIDEO_PLAYED: 'Video Played',
        VIDEO_PROGRESS: 'Video Progress Updated',
        VIEW_ALL_COLORS_CLICKED: 'View All Colors Clicked',
        WISHLIST_EMPTY_LINK_CLICKED: 'Empty Wishlist Link Clicked',
        WISHLIST_PRODUCT_ADDED: 'Product Added to Wishlist',
        WISHLIST_PRODUCT_ATC: 'Wishlist Product Added to Cart',
        WISHLIST_PRODUCT_REMOVED: 'Product Removed from Wishlist',
        WISHLIST_SHARED: 'Wishlist Shared',
      },
    }
  }

  /**
   * identify
   *
   * Makes Segment's identify call.
   * Littledata auto-identifies in certain cases, other cases are up to us.
   *
   * @see https://segment.com/docs/connections/sources/catalog/libraries/website/shopify-littledata/
   *
   * @param  string   The user's e-mail (to be hashed)
   * @param  object   The user's traits
   * @param  boolean  Option to merge event data with shared props
   */
  identify({ email, id = false, traits = {}, merge = true }) {
    if (merge) {
      // Create any shared traits
      this.accessCommonProperties()
      if (this.country) traits.countryCode = this.country
      if (this.presentmentCurrency)
        traits.currencyCode = this.presentmentCurrency
      if (this.language) traits.languageCode = this.language
      if (this.locale) traits.locale = this.locale
      if (window.navigator.userAgent)
        traits.userAgent = window.navigator.userAgent
    }

    if (email) {
      traits.email = email
      traits.emailDomain = email.split('@')[1]

      if (window.md5) {
        const userId = md5(email)
        analytics.identify(userId, traits, this.consentProperties)

        if (id) {
          // When there's an email and an id available, use alias to merge
          // identities, treating hashed email as the canonical id.
          // NOTE: This explicitly changes a previously set id to the hashed email.
          const previousId = id
          if (userId !== previousId) {
            analytics.alias(userId, previousId)
          }
        }
      }
    } else if (id) {
      // Had an id but not an email. Use the provided id so that
      // user activity can continue to be associated with it.
      analytics.identify(id, traits, this.consentProperties)
    } else {
      // User is anonymous.
      analytics.identify(traits, this.consentProperties)
    }

    return Promise.resolve(true)
  }

  /**
   * track
   *
   * Makes Segment's track call.
   *
   * @param  string   The event name
   * @param  object   The event properties
   * @param  boolean  Option to merge event data with shared props
   */
  track(name, data, merge = true) {
    const eventProperties = data || {}
    eventProperties.sent_from = this.CONSTANTS.SENT_FROM
    eventProperties.page_url = window.location.href.includes('?')
      ? window.location.href.split('?')[0]
      : window.location.href
    eventProperties.page_path = window.location.pathname.includes('?')
      ? window.location.pathname.split('?')[0]
      : window.location.pathname
    eventProperties.referrer = document.referrer

    const attentiveParams =
      'utm_medium=sms&utm_source=attentive&utm_campaign=category-abandonment-message'
    eventProperties.attentive_full_url = window.location.search
      ? `${window.location.href}&${attentiveParams}`
      : `${window.location.href}?${attentiveParams}`

    if (merge === true) {
      // Create any shared properties
      this.accessCommonProperties()
      if (this.country) eventProperties.country = this.country
      if (this.CONSTANTS.CURRENCY)
        eventProperties.currency = this.CONSTANTS.CURRENCY
      if (this.presentmentCurrency)
        eventProperties.presentment_currency = this.presentmentCurrency
      if (this.language) eventProperties.language = this.language
      if (this.locale) eventProperties.locale = this.locale
    }

    if (typeof analytics.track === 'function') {
      analytics.track(name, eventProperties, this.consentProperties)

      // @gtm
      this.dataLayerPush(name, eventProperties)

      // @intelligems
      window.igEvents = window.igEvents || []
      window.igEvents.push({
        event: name,
        properties: eventProperties,
      })

      return Promise.resolve(true)
    }

    return Promise.reject(new Error('analytics.track function was not found'))
  }

  /**
   * page
   *
   * Makes Segment's page call.
   *
   * @param  string   The page title
   * @param  object   The page properties
   */
  page(name, data) {
    if (typeof analytics.page === 'function') {
      analytics.page(name, data, this.consentProperties)
      this.dataLayerPush(this.CONSTANTS.EVENTS.PAGE_VIEWED, data)
    }
  }

  /**
   * Wraps segment calls into a try/catch to avoid these calls
   * creating side effects to the root customer experience.
   */
  protect(cb) {
    try {
      cb()
    } catch (error) {
      console.warn('Error with Segment call')
      console.log(error)
    }
  }

  /**
   * Pushes a Segment event to the Google Tag Manager datalayer.
   *
   * @param  string   The event name
   * @param  object   The event properties
   */
  dataLayerPush(name, data) {
    const dataForGTM = structuredClone(data) || {}
    dataForGTM.event = name
    dataForGTM.sent_from = 'website'

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(dataForGTM)
  }

  /**
   * Waits for Shopify object to be available and then
   * assigns some common properties from that object
   */
  async accessCommonProperties() {
    while (!Object.prototype.hasOwnProperty.call(window, 'Shopify')) {
      await new Promise((resolve) => setTimeout(resolve, 500))
    }
    this.country = window.Shopify?.country?.toLowerCase()
    this.language =
      window.Shopify?.locale?.toLowerCase() ||
      window.Shopify?.Checkout?.locale?.toLowerCase() ||
      undefined
    this.locale =
      window.Shopify?.routes?.root === '/'
        ? 'en-us'
        : window.Shopify.routes.root.replaceAll('/', '').toLowerCase()
    this.presentmentCurrency = window.Shopify?.currency?.active

    // Required for Segment consent management
    // https://segment.com/docs/privacy/consent-management/consent-in-segment-connections/#consent-object
    const preferences = window.Shopify?.customerPrivacy?.currentVisitorConsent()
    if (preferences) {
      this.consentProperties = {
        consent: {
          categoryPreferences: {
            Advertising: preferences.marketing,
            Analytics: preferences.analytics,
            Functional: preferences.preferences,
            DataSharing: preferences.sale_of_data,
          },
        },
      }
    }
  }
}

export const Segment = new SegmentClient()

// Make analytics tracking available outside of JS modules
registerGlobal(Segment, 'Segment', 'vendor')
